import { lazy } from "react"
import { SummarySkilling } from "slot-definitions"

const Skilling = lazy(() => import("./skilling"))
SummarySkilling.plug(<Skilling noContainer />)
